export default function MySQL_EDITOR() {
  return (
    <div>
      <h2>MySQL_EDITOR</h2>    </div>
  );
}